export default "__VITE_ASSET__CUJsUdqI__"